import { render, staticRenderFns } from "./email-confirmation.vue?vue&type=template&id=1b272ae3&"
import script from "./email-confirmation.vue?vue&type=script&lang=ts&"
export * from "./email-confirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports